package org.catharsis.spendtel.core.platform

import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.json.Json
import org.catharsis.spendtel.feature.data.CheckoutSessionRequest
import org.catharsis.spendtel.feature.data.StoragePathInput
import org.w3c.dom.url.URLSearchParams

private const val PENDING_REPORTS_KEY = "spendtel.pendingReportPaths"
private val pendingReportJson = Json { ignoreUnknownKeys = true }

actual fun openCheckoutUrl(url: String) {
    window.location.href = url
}

actual fun usesNativeStoreBilling(): Boolean = false

actual suspend fun purchaseConsumableReport(): StorePurchaseOutcome {
    error("Native store billing is only available on mobile platforms.")
}

actual fun paywallPurchasingButtonText(): String = "Opening checkout…"

actual fun purchaseCancelledMessage(): String = "Checkout cancelled."

actual suspend fun syncRevenueCatUser(userId: String) {
    // Web uses Stripe checkout.
}

actual suspend fun syncRevenueCatUserLoggedOut() {
    // Web uses Stripe checkout.
}

actual fun checkoutReturnPaths(): CheckoutSessionRequest {
    val origin = window.location.origin
    return CheckoutSessionRequest(
        successPath = "$origin/?purchase=success",
        cancelPath = "$origin/?purchase=cancelled",
    )
}

actual fun consumePurchaseReturnQuery(): PurchaseReturn? {
    val params = URLSearchParams(window.location.search)
    return when (params.get("purchase")) {
        "success" -> PurchaseReturn.Success
        "cancelled" -> PurchaseReturn.Cancelled
        else -> null
    }
}

actual fun clearPurchaseReturnQuery() {
    val url = window.location.pathname + window.location.hash
    window.history.replaceState(null, document.title, url)
}

actual object PendingReportStore {
    actual fun save(paths: List<StoragePathInput>) {
        val json = pendingReportJson.encodeToString(
            ListSerializer(StoragePathInput.serializer()),
            paths,
        )
        window.sessionStorage.setItem(PENDING_REPORTS_KEY, json)
    }

    actual fun load(): List<StoragePathInput>? {
        val json = window.sessionStorage.getItem(PENDING_REPORTS_KEY) ?: return null
        return runCatching {
            pendingReportJson.decodeFromString(
                ListSerializer(StoragePathInput.serializer()),
                json,
            )
        }.getOrNull()
    }

    actual fun hasPending(): Boolean = !load().isNullOrEmpty()

    actual fun clear() {
        window.sessionStorage.removeItem(PENDING_REPORTS_KEY)
    }
}
